import React from "react";

const Divider = () => (
  <div className="w-full flex items-center justify-between py-20">
    <span className="block w-1/4 h-[1px] bg-grey-200" />
    <p className="text-mobile-heading-6 md:text-desktop-heading-6 text-grey-600">
      OR
    </p>
    <span className="block w-1/4 h-[1px] bg-grey-200" />
  </div>
);

export default Divider;
